import dynamic from 'next/dynamic'

export const COMPONENT_RELATION_MAP = {
  'storefront.storefront-hero': dynamic(() => import('@components/StorefrontCategory/StorefrontHero')),
  'storefront.storefront-brand-strip': dynamic(() => import('@components/StorefrontCategory/BrandsCarousal')),
  'storefront.storefront-benefits': dynamic(() => import('@components/StorefrontCategory/BenefitsCarousal')),
  'storefront.storefront-benefit-card': dynamic(() => import('@components/StorefrontCategory/CategoryProduct')),
  'storefront.storefront-acko-edge': dynamic(() => import('@components/StorefrontCategory/AckoEdge')),
  'storefront.storefront-coverages': dynamic(() => import('@components/StorefrontCategory/Coverages')),
  'storefront.storefront-comparison': dynamic(() => import('@components/StorefrontCategory/ComparisonSection')),
  'storefront.storefront-impact-section': dynamic(() => import('@components/StorefrontCategory/OurImpactSection')),
  'storefront.storefront-recognition': dynamic(() => import('@components/StorefrontCategory/Recognition')),
  'storefront.storefront-quote': dynamic(() => import('@components/StorefrontCategory/GetQuote')),
  'storefront.storefront-categories': dynamic(() => import('@components/StorefrontCategory/Categories')),
  'home-page.reviews': dynamic(() => import('@components/Home/ReviewCarousel')),
  'home-page.banner-carousel': dynamic(() => import('@components/Home/Banner/carouselBanner')),
  'home-page.video': dynamic(() => import('@components/Home/Trust')),
}

export enum StorefrontCategorySlug {
  TRAVEL_INSURANCE = 'group-travel-insurance',
  HEALTH_INSURANCE = 'group-health-insurance',
  GIG_WORKER_HEALTH_INSURANCE = 'gig-worker-health-insurance',
  FINTECH_LOAN_PROTECTION_INSURANCE = 'fintech-loan-protection-insurance',
  ELECTRONIC_DEVICE_INSURANCE = 'electronic-device-insurance',
  HOME_PAGE = 'homepage',
}

const STOREFRONT_CATEGORY_SLUG_VALUES = new Set<string>(Object.values(StorefrontCategorySlug))

export function isStorefrontCategorySlug(slug: string): slug is StorefrontCategorySlug {
  return STOREFRONT_CATEGORY_SLUG_VALUES.has(slug)
}
